module.exports = __webpack_public_path__ + "img/access_bank_(diamond).b91f9a70.svg";